import { QueryClient } from '@tanstack/react-query';

/**
 * Единый QueryClient для admin-app.
 *
 * Cross-tenant данные оператора платформы обновляются нечасто — держим
 * staleTime 30s и отключаем refetch на фокус окна, как в manager-web.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
